// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
// Sibling imports
const toastsActions = require('./actions')
const Toasts = require('./component-dumb')
const { createNoticesSelector } = require('./selectors')

const MAX_VISIBLE_NOTICES = 5

function mapStateToProps() {
  const noticesSelector = createNoticesSelector(MAX_VISIBLE_NOTICES)
  return function (state) {
    return {
      notices: noticesSelector(state)
    }
  }
}

const mapDispatchToProps = {
  onDismiss: toastsActions.dismissNotice
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withImmutableToJS(
    Toasts
  )
)
